import { useQuery, useMutation, useQueryClient } from "react-query";
import {
	getLookupsPhytosanitaryProgram,
	getPhytosanitaryProgram,
	importExcelPhytosanitaryProgram,
	validatePhytosanitaryProgramName,
	savePhytosanitaryProgram,
	createApplicationOrderFromProgram,
	getPhytosanitaryProgramProgress,
	deletePhytosanitaryProgram,
	deletePhytosanitaryProgramApplication,
	addPhytosanitaryProgramRows,
} from "@/api/Planning/phytosanitary-program/phytosanitary-program-api";

export const key = "phytosanitary-program";

export function usePhytosanitaryProgramLookups(filters, options = {}) {
	return useQuery([key, "lookups", filters], () => getLookupsPhytosanitaryProgram(filters), options);
}

export function usePhytosanitaryProgram(filters, options = {}) {
	return useQuery([key, "list", filters], () => getPhytosanitaryProgram(filters), options);
}

export function useImportExcelPhytosanitaryProgram(onAfterRefetch) {
	const queryClient = useQueryClient();

	return useMutation((formData) => importExcelPhytosanitaryProgram(formData), {
		onSuccess: async () => {
			queryClient.invalidateQueries([key, "list"]);
			queryClient.invalidateQueries([key, "progress"]);
			await queryClient.refetchQueries([key, "lookups"]).catch(() => {});
			onAfterRefetch?.();
		},
	});
}

export function useValidatePhytosanitaryProgramName() {
	return useMutation((fileName) => validatePhytosanitaryProgramName(fileName));
}

export function useSavePhytosanitaryProgram() {
	const queryClient = useQueryClient();

	return useMutation(savePhytosanitaryProgram, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}

export function useCreateApplicationOrder() {
	const queryClient = useQueryClient();

	return useMutation(createApplicationOrderFromProgram, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
		},
	});
}

export function usePhytosanitaryProgramProgress(filters, options = {}) {
	return useQuery([key, "progress", filters], () => getPhytosanitaryProgramProgress(filters), options);
}

export function useDeletePhytosanitaryProgram() {
	const queryClient = useQueryClient();

	return useMutation(deletePhytosanitaryProgram, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
			queryClient.invalidateQueries([key, "progress"]);
			queryClient.invalidateQueries([key, "lookups"]);
		},
	});
}

export function useDeletePhytosanitaryProgramApplication() {
	const queryClient = useQueryClient();

	return useMutation(deletePhytosanitaryProgramApplication, {
		onSuccess: () => {
			queryClient.invalidateQueries([key, "list"]);
			queryClient.invalidateQueries([key, "progress"]);
		},
	});
}

export function useAddPhytosanitaryProgramRows() {
	return useMutation(addPhytosanitaryProgramRows);
}
